import Swiper from 'swiper/bundle'
import { Fancybox } from '@fancyapps/ui'

Fancybox.bind('[data-fancybox="training_centers-gallery"]', {
  Thumbs: {
    type: 'classic',
  },
})

new Swiper('.header-training-centers__gallery-slider', {
  slidesPerView: 2,
  spaceBetween: 10,
  breakpoints: {
    576: {
      spaceBetween: 2,
      grid: {
        rows: 2,
        fill: 'row',
      },
    },
  },
  autoplay: {
    delay: 3000,
  },
})
